/*************************************************/
/* SEARCHBAR                                      /
/*************************************************/

export function searchbar(body) {
    let searchContainer,
        searchForm,
        searchInput,
        searchToggler;
    const showSearchClass = 'search-active',
    searchFormButtonClass ='search-form__button',
    searchBarSelector = '.search-bar',
    searchFormInputSelector = '.search-form__input',
    searchBarToggleSelector = '.search-bar__toggle';

    const init = function () {
        searchContainer = document.querySelector(searchBarSelector);
        if (searchContainer != null) {
            searchForm = searchContainer.querySelector('form');
            searchInput = searchContainer.querySelector(searchFormInputSelector);
            searchToggler = document.querySelectorAll(searchBarToggleSelector);
            
            if(searchToggler){
                searchToggler.forEach(toggler => {
                    toggler.addEventListener('click', e => {
                        e.stopPropagation();
                        handleSearchBarVisibility();
                        searchInput.focus();
                    });
                })
            }
       

            searchContainer.addEventListener('click', e => {
                e.stopPropagation();
            });

            searchContainer.addEventListener('focusout', e => {
                if(e.target.classList.contains(searchFormButtonClass)) {
                    closeSearch();
                }
            });

            body.addEventListener('click', e => {
                closeSearch();
            });
        }


        function handleSearchBarVisibility() {
            if (!body.classList.contains(showSearchClass)) {
                openSearch();
            } else {
                closeSearch();
            }
        }

        function openSearch() {
            body.classList.add(showSearchClass);
        }

        function closeSearch() {
            body.classList.remove(showSearchClass);
        }
    };

    init();
}